module.exports = __webpack_public_path__ + "static/img/icon-loading.cd609076.gif";